"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1060,9635,6029],{

/***/ 41749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/






var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="center"`. */
    'justify-content-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justifyContent="flex-end"`. */
    'justify-content-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justifyContent="space-between"`. */
    'justify-content-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justifyContent="space-around"`. */
    'justify-content-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="space-evenly"`. */
    'justify-content-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      justify = props.justify,
      _props$justifyContent = props.justifyContent,
      justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "justifyContent", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: className,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
var StyledGrid = (0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) { var requireProp; }

/* harmony default export */ __webpack_exports__["Z"] = (StyledGrid);

/***/ }),

/***/ 89659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93871);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var _utils_useIsFocusVisible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24896);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17294);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);











var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = (0,_utils_useIsFocusVisible__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, classes["underline".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'MuiLink'
})(Link));

/***/ }),

/***/ 81064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var hub_components_Sticky__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95717);
/* harmony import */ var lib_cssVariables__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75150);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19916);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  flex-shrink: 0;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n  list-style: none;\n  display: flex;\n  margin: 0;\n  overflow-x: auto;\n  background-color: #f8f8f8;\n  justify-content: center;\n\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin-right: 1rem;\n  color: ",
        ";\n  text-decoration: none;\n  background: ",
        ";\n  border-radius: 500px;\n  padding: ",
        ";\n  font-size: 14px;\n  font-weight: 600;\n\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










function CategoriesBanner(param) {
    var categories = param.categories, activeCategory = param.activeCategory, title = param.title;
    var isMobile = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_8__/* .useBreakpointDown */ .a)("sm");
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_9__/* .useTranslation */ .$)("hub").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var activeCategoryRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(activeCategoryRef === null || activeCategoryRef === void 0 ? void 0 : activeCategoryRef.current) || !isMobile) {
            return;
        }
        var scrollActiveCategoryToCenter = function() {
            activeCategoryRef.current.scrollIntoView({
                inline: "center",
                block: "end",
                behavior: "smooth"
            });
        };
        scrollActiveCategoryToCenter();
    }, [
        router.asPath,
        isMobile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                bgcolor: "#f8f8f8",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(hub_components_Sticky__WEBPACK_IMPORTED_MODULE_6__/* .Sticky */ .L, {
                hideOnScroll: isMobile,
                as: "nav",
                top: "var(".concat(lib_cssVariables__WEBPACK_IMPORTED_MODULE_7__/* .cssVars.topBarHeight.name */ .D.topBarHeight.name, ")"),
                "aria-label": t("category.blogCategories"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryList, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/hub",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryLink, {
                                    ref: activeCategory === "all" ? activeCategoryRef : undefined,
                                    active: activeCategory === "all",
                                    children: "Hub Homepage"
                                })
                            })
                        }),
                        categories.map(function(category) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/hub/".concat(category.slug),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CategoryLink, {
                                        as: "a",
                                        ref: activeCategory.slug === category.slug ? activeCategoryRef : undefined,
                                        active: activeCategory.slug === category.slug,
                                        children: category.title
                                    }, category.slug)
                                })
                            }, category.slug);
                        })
                    ]
                })
            })
        ]
    });
}
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].li */ .ZP.li(_templateObject());
var CategoryList = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].ul */ .ZP.ul(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("sm");
});
var CategoryLink = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].a */ .ZP.a(_templateObject2(), function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.palette.common.white : theme.palette.text.secondary;
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.palette.secondary.light : theme.palette.text.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 2.5);
}, function(param) {
    var active = param.active;
    return !active && "hsla(69, 53%, 70%, .19)";
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.dark;
});
/* harmony default export */ __webpack_exports__["Z"] = (CategoriesBanner);


/***/ }),

/***/ 79635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55352);






function ContentfulImage(_param) {
    var src = _param.src, width = _param.width, height = _param.height, _layout = _param.layout, layout = _layout === void 0 ? "responsive" : _layout, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "height",
        "layout",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        alt: alt,
        src: (0,hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getContentfulImageUrl */ .l)(src),
        width: width,
        height: height,
        layout: layout,
        objectFit: "cover",
        quality: "85"
    }, restProps));
}
/* harmony default export */ __webpack_exports__["default"] = (ContentfulImage);


/***/ }),

/***/ 87033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39138);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19521);
/* harmony import */ var hub_components_ContentfulImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79635);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  font-weight: 400;\n  color: #3c4340;\n  line-height: 94%;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.9);\n    transform: scale(1.1);\n  }\n\n  &:hover .article-title {\n    text-decoration: underline;\n  }\n  display: flex;\n  flex-direction: column;\n  text-decoration: inherit;\n  height: 100%;\n  color: inherit;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n\n  ",
        " {\n    min-height: fit-content;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: inherit;\n  padding: ",
        ";\n  font-weight: 500;\n  line-height: ",
        "px;\n  letter-spacing: 0.15px;\n  font-size: 14px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-top: auto;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  padding: ",
        ";\n  background: ",
        ";\n  border-radius: 500px;\n  font-size: 12px;\n  margin-right: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








function HubArticleCard(_param) {
    var title = _param.title, description = _param.description, hubslug = _param.hubslug, heroImage = _param.heroImage, category = _param.category, tags = _param.tags, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "title",
        "description",
        "hubslug",
        "heroImage",
        "category",
        "tags"
    ]);
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("static_pages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: "/hub/".concat(hubslug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledArticleCard, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, restProps), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                    children: heroImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(hub_components_ContentfulImage__WEBPACK_IMPORTED_MODULE_6__["default"], {
                        src: heroImage,
                        width: 340,
                        height: 212,
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pt: 2,
                            children: tags && tags.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                mb: 3,
                                height: 20,
                                children: tags.map(function(tag) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Tag, {
                                        children: tag
                                    }, tag);
                                })
                            }) : null
                        }),
                        category && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CategoryLabel, {
                            mt: 1,
                            pb: {
                                md: 1
                            },
                            children: [
                                t("hub:post.categoryLabel"),
                                ": ",
                                category.title
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            mt: 1,
                            mb: 2.5,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                href: "/hub/".concat(hubslug),
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                        className: "article-title",
                                        variant: "h5",
                                        component: "h2",
                                        color: "textPrimary",
                                        children: lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default()(title, {
                                            length: 50
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            mb: 3,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                variant: "body1",
                                children: lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default()(description, {
                                    length: 100
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CatererFooter, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/hub/".concat(hubslug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonLink, {
                            rounded: false,
                            variant: "tertiary",
                            children: t("articleCards.readMore")
                        })
                    })
                })
            ]
        }))
    });
}
var CategoryLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT)(_templateObject());
var StyledArticleCard = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].a */ .ZP.a(_templateObject1());
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div */ .ZP.div(_templateObject2(), function(props) {
    return props.theme.spacing(1, 1, 1, 1);
});
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div */ .ZP.div(_templateObject3(), function(props) {
    return props.theme.spacing(0, 0);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].a */ .ZP.a(_templateObject4());
var ButtonLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx)(_templateObject5(), function(props) {
    return props.theme.spacing(1, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var CatererFooter = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].footer */ .ZP.footer(_templateObject6());
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].span */ .ZP.span(_templateObject7(), function(props) {
    return props.theme.spacing(0.3, 2);
}, function(props) {
    return props.theme.palette.grey[100];
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ __webpack_exports__["Z"] = (HubArticleCard);


/***/ }),

/***/ 95717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Sticky; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70131);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: -",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: all 0.3s ease-out;\n  z-index: 50;\n  position: sticky;\n  top: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Sticky = function(_param) {
    var children = _param.children, top = _param.top, hideOnScroll = _param.hideOnScroll, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "top",
        "hideOnScroll"
    ]);
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), prevScrollY = ref1[0], setPrevScrollY = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isHiddenOnScroll = ref2[0], setHiddenOnScroll = ref2[1];
    var ref3 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .YD)({
        threshold: 1
    }), ref4 = ref3.ref, entry = ref3.entry;
    var height = entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.height;
    var handleScroll = function() {
        if (!hideOnScroll) return;
        var currentScrollY = window.scrollY;
        var scrollDirection = currentScrollY < prevScrollY ? "up" : "down";
        if (window.scrollY === 0 || prevScrollY == currentScrollY) {
            return;
        }
        if (scrollDirection === "down") {
            setHiddenOnScroll(true);
        }
        if (scrollDirection === "up") {
            setHiddenOnScroll(false);
        }
        setPrevScrollY(currentScrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        hideOnScroll,
        prevScrollY
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        ref: ref4,
        height: height,
        hideOnScroll: hideOnScroll,
        isHiddenOnScroll: isHiddenOnScroll,
        top: top
    }, restProps), {
        children: children
    }));
};
var StickyContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject1(), function(param) {
    var top = param.top;
    return top || 0;
}, function(param) {
    var hideOnScroll = param.hideOnScroll, isHiddenOnScroll = param.isHiddenOnScroll, height = param.height;
    return hideOnScroll && isHiddenOnScroll && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject(), height);
});


/***/ }),

/***/ 81060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CATEGORY_ARTICLES_PER_PAGE": function() { return /* binding */ CATEGORY_ARTICLES_PER_PAGE; },
  "HubCategory": function() { return /* binding */ HubCategory; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/ArrowBack.js


/* harmony default export */ var ArrowBack = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), 'ArrowBack'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/ArrowForward.js


/* harmony default export */ var ArrowForward = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward'));
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/hub/components/CategoriesBanner.js
var CategoriesBanner = __webpack_require__(81064);
// EXTERNAL MODULE: ./src/hub/components/HubArticleCard.js
var HubArticleCard = __webpack_require__(87033);
// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./src/static_pages/components/FooterLinks.tsx
var FooterLinks = __webpack_require__(6029);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/pages/hub/[category]/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #87a34e;\n  text-decoration: none;\n  font-size: 48px;\n\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n\n  ",
        " {\n    font-weight: 600;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #3c4340;\n\n  :hover {\n    color: #87a34e;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  text-decoration: none;\n  background: none;\n  cursor: pointer;\n  padding: 0.7rem 1rem;\n  margin-right: 0.5rem;\n  border-radius: 4px;\n  color: ",
        ";\n  font-weight: ",
        ";\n\n  :hover {\n    color: #87a34e;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var ARTICLE_COLUMNS = 3;
var MAX_ARTICLE_ROWS = 7;
var __N_SSG = true;
var CATEGORY_ARTICLES_PER_PAGE = ARTICLE_COLUMNS * MAX_ARTICLE_ROWS;
function HubCategory(param) {
    var articles = param.articles, categories = param.categories, activeCategory = param.activeCategory, page = param.page, hasNextPage = param.hasNextPage, hasPrevPage = param.hasPrevPage, pageCount = param.pageCount, ratings = param.ratings;
    var t = (0,useTranslation/* useTranslation */.$)("hub").t;
    var pages = new Array(pageCount).fill(1, 0, pageCount);
    var getPageRoute = function(pageNumber) {
        return "/hub/".concat(activeCategory.slug, "/page/").concat(pageNumber);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Hub - ",
                        activeCategory.title,
                        " | heycater!"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesBanner/* default */.Z, {
                categories: categories,
                activeCategory: activeCategory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    as: "header",
                    pt: {
                        xs: 6,
                        md: 9.5
                    },
                    pb: {
                        xs: 3,
                        md: 9.5
                    },
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyCategoryTitle, {
                            variant: "h2",
                            pt: {
                                xs: 0,
                                md: 3
                            },
                            pb: 3,
                            component: "h1",
                            align: "center",
                            children: activeCategory.title
                        }),
                        (activeCategory === null || activeCategory === void 0 ? void 0 : activeCategory.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyCategorySubtitle, {
                            pb: {
                                xs: 2,
                                md: 3
                            },
                            variant: "subtitle2",
                            textAlign: "center",
                            component: "p",
                            children: activeCategory.description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mb: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            direction: "row",
                            spacing: 6,
                            px: 1.5,
                            sx: {
                                gridTemplateColumns: "repeat(5, 1fr)"
                            },
                            children: articles.map(function(article) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    item: true,
                                    children: /*#__PURE__*/ (0,react.createElement)(HubArticleCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
                                        key: article.hubslug,
                                        mb: 3
                                    }))
                                }, article.slug);
                            })
                        })
                    }),
                    pages.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        as: "nav",
                        "aria-label": "Pagination",
                        mb: 8,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            hasPrevPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: getPageRoute(page - 1),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationButton, {
                                    as: "a",
                                    size: "md",
                                    rounded: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                            fontSize: "16px",
                                            ml: 0.5,
                                            children: t("common:labels.previous")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                mx: 3,
                                children: pages.map(function(_, pageIndex) {
                                    var pageNumber = pageIndex + 1;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        passHref: true,
                                        href: getPageRoute(pageNumber),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageButton, {
                                            as: "a",
                                            active: page === pageNumber,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                fontSize: "16px",
                                                as: "span",
                                                children: pageNumber
                                            })
                                        })
                                    }, pageNumber);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: getPageRoute(page + 1),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationButton, {
                                        as: "a",
                                        size: "md",
                                        rounded: true,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                fontSize: "16px",
                                                mr: 0.5,
                                                children: t("common:labels.next")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward, {})
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks["default"], {
                pb: {
                    xs: 2,
                    sm: 6
                },
                pt: {
                    xs: 2,
                    sm: 3
                }
            })
        ]
    });
}
var TypographyCategoryTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("sm");
});
var TypographyCategorySubtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("sm");
});
var PaginationButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject2());
var PageButton = styled_components_browser_esm/* default.button */.ZP.button(_templateObject3(), function(props) {
    return props.active ? "#87a34e" : "#3C4340";
}, function(props) {
    return props.active ? "700" : "400";
});
/* harmony default export */ var _category_ = (HubCategory);


/***/ }),

/***/ 6029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FooterLinks; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89659);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19521);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10758);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function FooterLinks(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("static_pages").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var cities = [
        {
            key: "berlin",
            link: "berlin"
        },
        {
            key: "muenchen",
            link: "muenchen"
        },
        {
            key: "hamburg",
            link: "hamburg"
        },
        {
            key: "frankfurt-am-main",
            link: "frankfurt"
        },
        {
            key: "duesseldorf",
            link: "duesseldorf"
        },
        {
            key: "koeln",
            link: "koeln"
        },
        {
            key: "leipzig",
            link: "leipzig"
        },
        {
            key: "hannover",
            link: "hannover"
        }, 
    ];
    var countries = [
        "austria",
        "germany",
        "switzerland"
    ];
    var countriesLinksMapping = {
        switzerland: "schweiz",
        germany: "deutschland",
        austria: "oesterreich"
    };
    var cateringCategories = [
        {
            key: "fingerfood",
            url: "/fingerfood"
        },
        {
            key: "breakfast",
            url: "/fruehstueck"
        },
        {
            key: "foodTruck",
            url: "/food-truck"
        },
        {
            key: "event",
            url: "/event"
        },
        {
            key: "buffet",
            url: "/buffet"
        },
        {
            key: "cocktail",
            url: "/bar-cocktail"
        },
        {
            key: "coffee",
            url: "/mobile-kaffeebar"
        },
        {
            key: "vegan",
            url: "/vegan"
        },
        {
            key: "bbq",
            url: "/grill-catering"
        },
        {
            key: "summer_party",
            url: "/sommerfest"
        },
        {
            key: "company_party",
            url: "/catering-firmenfeier"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "nav"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            pb: 2,
            pt: 4,
            id: "footerLinksSection",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mb: 3,
                            children: t("footerLinks.cateringCategories")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cateringCategories.map(function(category) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale).concat(category.url),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.categories.".concat(category.key))
                                            })
                                        })
                                    }, category.key);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.cities")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cities.map(function(city) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(city.link),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.cateringIn", {
                                                    city: t("common:cities.".concat(city.key))
                                                })
                                            }, city.key)
                                        })
                                    }, city.link);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.countries")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: countries.map(function(country) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(countriesLinksMapping[country]),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("common:countries.".concat(country))
                                            }, country)
                                        })
                                    }, country);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
var StyledGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject(), function(props) {
    return props.theme.spacing(0, 0, 0, 1);
});


/***/ })

}]);